import { CANCEL_PENALTY_TYPE } from '.';

export const FINANCE_STATUS = {
  UNPAID: 'UNPAID',
  PAID: 'PAID',
};

export const FINANCE_REFUND_LABEL = { // % hoàn tiền dựa trên % phạt hủy phòng
  [CANCEL_PENALTY_TYPE.FIRST_NIGHT.value]: 'Hoàn đêm đầu tiên',
  [CANCEL_PENALTY_TYPE['50_PERCENT'].value]: '50% hoàn tiền',
  [CANCEL_PENALTY_TYPE['100_PERCENT'].value]: '',
  '0_PERCENT': '100% hoàn tiền', // type 0_PERCENT là tự định nghĩa (không phải từ server)
};

export const FINANCE_TAB_LIST = [
  {
    name: 'Tất cả',
    value: null,
  },
  {
    name: 'Chưa thanh toán',
    value: FINANCE_STATUS.UNPAID,
  },
  {
    name: 'Đã thanh toán',
    value: FINANCE_STATUS.PAID,
  },
];

export const FINANCE_TYPE = {
  [FINANCE_STATUS.PAID]: {
    key: FINANCE_STATUS.PAID,
    label: 'Đã thanh toán',
  },
  [FINANCE_STATUS.UNPAID]: {
    key: FINANCE_STATUS.UNPAID,
    label: 'Chưa thanh toán',
  },
};

export const COMMISSION = 0.15;

export const FINANCE_BREADCRUMB = [
  {
    name: 'Tài chính',
    isActive: true,
    link: '',
  },
];

export const FINANCE_PAGE_LIMIT = 10;

const currentYear = new Date().getFullYear();

export const FINANCE_YEAR_OPTIONS = Array.from({ length: 30 }, (item, index) => ({
  label: `${currentYear - index}`,
  value: currentYear - index,
}));
